<div class="top-section">
  <div class="flex items-center">
    <app-svg name="hamburger" class="common-hamburger" (click)="ss.toggleSidebar()" role="button"
      [color]="cc.isNarrowScreen() ? ss.theme().color12 : ss.theme().color8"></app-svg>
    <h4 class="heading mb-0">{{ config.name }}</h4>
  </div>
  <div class="flex items-center gap-6">
    <!-- Add list — desktop only -->
    <app-svg name="plus" class="filter-icon" role="button" (click)="openListForm()" *ngIf="!cc.isNarrowScreen()"
      [color]="ss.theme().color8" [width]="'15px'" [height]="'15px'"></app-svg>
    <app-notification [iconColor]="cc.isNarrowScreen() ? ss.theme().color12 : null"></app-notification>
    <!-- Two-button filter layout: Favorite + Filter Row Toggle -->
    @if(listStore.allLists().length > 0 || isAnyFilterApplied()){
    <app-svg [name]="filters.isFav() ? 'favouriteFilterSelected' : 'favouriteFilterUnselected'" class="filter-icon"
      role="button" (click)="toggleFavoriteFilter()"
      [color]="cc.isNarrowScreen() ? ss.theme().color12 : ss.theme().color8">
    </app-svg>
    <app-svg [name]="isFilter ? 'filterOutline' : 'filter'" class="filter-icon icon-mirror-rtl" role="button"
      (click)="toggleFilter()" [color]="cc.isNarrowScreen() ? ss.theme().color12 : ss.theme().color8">
    </app-svg>
    }

    <app-svg name="more" class="more-icon" (click)="openKebabMenu()" role="button"
      [color]="cc.isNarrowScreen() ? ss.theme().color12 : ss.theme().color8"></app-svg>
  </div>
</div>

<div class="body-section position-relative">
  <div class="filter-block" [ngClass]="{'h-auto filtered': isFilter}" dragScroll>
    <!-- Filter order: Search, Hashtag, Status, Access, Last Updated -->
    <!-- Note: Favourite filter moved to button bar (alongside filter toggle button) -->

    <!-- 1. Search - always first -->
    <app-filter-search [signal]="filters.filterQuery" [name]="''" class="me-2"></app-filter-search>

    <!-- 2. Hashtag - multi-select -->
    <app-filter-hashtag [signal]="filters.tags" class="me-2"></app-filter-hashtag>

    <!-- 3. Status - multi-select (incomplete/completed) -->
    <app-filter-status [value]="filters.status" [multiple]="true" [hiddenValues]="['inprogress', 'skipped']"
      class="me-2"></app-filter-status>

    <!-- 4. Access - multi-select (owner/editor/viewer) -->
    <app-filter-role [value]="filters.accessRoles" [multiple]="true" class="me-2"></app-filter-role>

    <!-- 5. Last Updated - date range picker -->
    <app-filter-date-range [startDate]="filters.startDate" [endDate]="filters.endDate" [label]="'Last Updated'"
      class="me-2"></app-filter-date-range>

    @if (isFiltered()) {
    <button class="btn btn-filter btn-clear" (click)="clearFilters()">{{ ss.t('common_clearAll') }}</button>
    }
  </div>

  <div class="list-block entity-block-container"
    [ngClass]="{'filter-applied': isFilter, 'no-filter': !isFilter, 'nolsit-block': filteredLists().length === 0}">

    <ng-container *ngIf="listGroupBy() === 'none' && filteredLists().length !== 0">
      <ng-container
        *ngTemplateOutlet="listsBlock; context: { $implicit: filteredLists(), groupId: 'noGroup' }"></ng-container>
    </ng-container>

    <ng-container *ngIf="listGroupBy() !== 'none' && filteredLists().length !== 0">
      <ng-container *ngFor="let group of hashtagGroup(); let i = index;">
        <div class="text-16-400 color-35 ri-px-4 ri-py-3 ri-bb-2 flex items-center justify-between"
          [style.border-radius]="!cc.isNarrowScreen() ? '8px' : null" [style.background]="'var(--color6)'" role="button"
          [attr.isOpen]="getIsOpen()" #tgroupHead (click)="toggleChildGroup(tgroupHead,'listGroup' + i)">
          <span>{{ group.name }}</span>
          <span class="group-count" [ngClass]="{'!hidden': !listGroupedViewType().includes('showCounts')}">{{
            group.data.length }}</span>
        </div>
        <ng-container
          *ngTemplateOutlet="listsBlock; context: { $implicit: group.data, groupId: 'listGroup' + i }"></ng-container>
      </ng-container>
    </ng-container>

    <ng-template #listsBlock let-element let-groupId="groupId">
      <div [ngClass]="listGroupBy() === 'none' ? 'row-nogroup' : 'row-grouped'" [attr.id]="groupId"
        [attr.isGroupOpened]="getIsOpen()">
        <div *ngFor="let list of element; let i = index;">
          <app-list-block [listId]="list.id" [show]="listShow()"
            [blockClass]="'ri-bb-2 entity-block ri-px-4 ri-py-3'"></app-list-block>
        </div>
      </div>
    </ng-template>

    <app-no-result-block class="flex justify-center items-center h-full"
      [imagePlaceholder]="listStore.allLists().length === 0 ? 'featuresPlaceholder' : 'searchPlaceholder'"
      [placeholder]="listStore.allLists().length === 0 ? 'common_emptyContent' : 'common_noResultFound'"
      *ngIf="listStore.allLists().length === 0 || (listStore.allLists().length > 0 && filteredLists().length === 0)"
      [showQuickGuide]="listStore.allLists().length === 0 ? true : false"></app-no-result-block>
  </div>
</div>

<!-- Bottom Bar with projected FAB -->
<app-mobile-bottom-bar>
  <button class="mobile-fab" (click)="openListForm()" [attr.aria-label]="ss.t('aria_addNewList')">
    <app-svg name="plus" [color]="ss.theme().color12" style="width: 18px; height: 18px;"></app-svg>
  </button>
</app-mobile-bottom-bar>